/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { registerLocale } from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

registerLocale(en);
